
import ProductsList from "../components/Products/ProductsList"
const Speakers = () => {
    return (
        <>
        <ProductsList />
        </>
   
    )
}

export default Speakers